// Filter and page tabs (.seg: All / Invoices / Credit notes…; the tab rows of Accounts, Pre-sales, Projects…): the
// white pill slides from the tab that was on to the one clicked, instead of jumping. Drawn for a moment by a ghost
// element; the tabs themselves are unchanged.
const ROWS = '.seg, .intel-tabs.prj-tabs, .intel-tabs.lg-views, .ic-tabs';
const ON = ':scope > button:is([aria-pressed="true"], [aria-selected="true"], .on)';
export function startSegSlide(): () => void {
  const onClick = (e: MouseEvent) => {
    const btn = (e.target as Element | null)?.closest<HTMLElement>('button');
    const seg = btn?.parentElement;
    if (!btn || !seg?.matches(ROWS) || window.matchMedia?.('(prefers-reduced-motion: reduce)').matches) return;
    const prev = seg.querySelector<HTMLElement>(ON);
    if (!prev || prev === btn) return;
    const from = { left: prev.offsetLeft, top: prev.offsetTop, width: prev.offsetWidth, height: prev.offsetHeight };
    // After React has marked the new tab.
    requestAnimationFrame(() => requestAnimationFrame(() => {
      const next = seg.querySelector<HTMLElement>(ON);
      if (!next || next === prev || !seg.isConnected) return;
      const ghost = document.createElement('span');
      ghost.className = 'seg-ghost';
      Object.assign(ghost.style, { left: `${from.left}px`, top: `${from.top}px`, width: `${from.width}px`, height: `${from.height}px` });
      seg.append(ghost);
      seg.classList.add('seg-moving');
      const dx = next.offsetLeft - from.left;
      const dy = next.offsetTop - from.top;
      const anim = ghost.animate(
        [{ transform: 'translate(0, 0)', width: `${from.width}px` }, { transform: `translate(${dx}px, ${dy}px)`, width: `${next.offsetWidth}px` }],
        { duration: 280, easing: 'cubic-bezier(.3, 1.2, .5, 1)', fill: 'forwards' },
      );
      const done = () => { ghost.remove(); seg.classList.remove('seg-moving'); };
      anim.onfinish = done;
      anim.oncancel = done;
    }));
  };
  document.addEventListener('click', onClick, true);
  return () => document.removeEventListener('click', onClick, true);
}
